module.exports = __webpack_public_path__ + "img/twitter-x.5f745c3a.svg";